import login from './login';

export default {
  language: 'pl',
  country: 'pl',
  name: 'Polski',
  embeddedLocale: login,
};
